import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getYearPayment = async (an8) => {


  const token = await authHeader();

  return axios
    .get(`${ baseUrl }/bbva/year/${an8}` ,{
      headers: token 
    }
    )
    .then(response => {
      return response.data;
     }
     )
};
const getMonthPayment = async (an8) => {


  const token = await authHeader();

  return axios
    .get(`${ baseUrl }/bbva/month/${an8}` ,{
      headers: token 
    }
    )
    .then(response => {
      return response.data;
     }
     )
};

const getAlldetailPaymentByFilters = async (date, an8, rows, page,dateRange) => {

   const data = {
    dateTransaction: date ? date : null,
    page: page ? page: null,
    row: rows ? rows: null,
    startDate: dateRange. firstDateOfMonth,
    endDate: dateRange.lastDatefMonth,

  };

console.log(data)
console.log(date)
      console.log(an8)
      console.log(page)
      console.log(rows)

  const url = `${ baseUrl }/bbva/invoicePaid/${an8}`;

  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    }
    )
    .then(response => {
      return response.data;
      }
      )
};
const downloadDetailPaymentsXls = async(an8, data) =>{
  const token = await authHeader();
  const url =`${ baseUrl }/bbva/excel/${an8}`

  return axios.post(url,data,{
    headers:token
  }).then((response) => {
    return response.data
  })
}


export default {
  getAlldetailPaymentByFilters,
  getYearPayment,
  getMonthPayment,
  downloadDetailPaymentsXls,
};